import Toggle from '@/components/Toggle';
import { Error } from '@/components/Typography';

type Props = {
  checked: boolean;
  disabled: boolean;
  error?: string | null;
  onToggleChange: (obj: any) => void;
};

const ToggleAutoApprove = ({
  checked,
  disabled,
  error,
  onToggleChange,
}: Props) => {
  const green = '#45a735';

  const onChange = (value: boolean) => {
    onToggleChange(value);
  };
  return (
    <>
      <div style={{ display: 'flex', float: 'right' }}>
        <p style={{ color: green, margin: '6px', fontWeight: 700 }}>
          Finalize Automatically
        </p>
        <Toggle
          color={green}
          disabled={disabled}
          initial={checked}
          onToggleChange={onChange}
        />
      </div>
      {error && (
        <div style={{ textAlign: 'center', clear: 'both', margin: '10px' }}>
          <Error>{error}</Error>
        </div>
      )}
    </>
  );
};

export default ToggleAutoApprove;
